export enum TimereportSendingToCustomerStatus {
  Sent = "Sent",
  Approved = "Approved",
  Rejected = "Rejected",
  Expired = "Expired",
  Invalid = "Invalid"
}
